import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService, BzgSlideDown } from 'bz-genome-angular';
import { ConnectEventStreamingService } from '../core/connect-event-streaming.service';
import { MessageService } from '../core/message.service';
import { PendingChangesConnectAlertComponent } from '../modal-actions/connect-pendingchanges.component';
import { Utils } from '../core/trigger.util';
import { ConnectEventStreamingDetailComponent } from './connect-event-streaming-detail/connect-event-streaming-detail.component';

@Component({
  selector: 'biz-connect-event-streaming',
  templateUrl: './connect-event-streaming.component.html',
  styleUrls: ['./connect-event-streaming.component.scss'],
  animations: [BzgSlideDown]
})
export class ConnectEventStreamingComponent implements OnInit {

  eventStreamType: Array<IEventStreamType>;
  selectedEvent: IEventStreamingEvent;
  selectedEventOrig: IEventStreamingEvent;
  isBusy: boolean;

  @ViewChild('eventStreamingDetail', { static: false }) eventStreamingDetail: ConnectEventStreamingDetailComponent;

  constructor(
    private _modalService: BzgModalService,
    private _translateService: TranslateService,
    private _connectEventStreamingService: ConnectEventStreamingService,
    private messageService: MessageService
  ) { }

  async ngOnInit() {
    this.isBusy = true;
    var promise = this._connectEventStreamingService.getEventStreamConnections();
    promise.then((result) => {
       this.eventStreamType = result;       
       this.eventStreamType.forEach((item) => {
        item.events.sort((a, b) => a.displayName.localeCompare(b.displayName));
      });
      this.isBusy = false;
    });
    promise.catch((result) => {
      this.isBusy = false;
    });
  }

  async selectKafkaConnection(connection: IKafkaConfiguration) {
    if (this.selectedEvent && this.eventStreamingDetail?.areThereAnyPendingChanges()) {
      this._showPendingChangesDialog(
        () => {
          this.saveKafkaConfiguration();
        },
        () => {
          this.loadKafkaConfiguration(connection.id);
        }
      );
    } else {
      this.loadKafkaConfiguration(connection.id);
    }
  }

  private async loadKafkaConfiguration(id: string) {
    this.isBusy = true;
    try {
      const configuration = await this._connectEventStreamingService.getEventStreamConfiguration(id);
      this.selectedEventOrig = configuration;
      this.selectedEvent = Utils.copyObject(configuration);
    } catch (error) {
      this._translateService.get('EVENT_STREAMING.ERROR_LOADING_DETAILS').subscribe((message: string) => {
        this.messageService.showError(message);
      });
    } finally {
      this.isBusy = false;
    }
  }

  public async saveKafkaConfiguration() {
    if (!this.selectedEvent) {
      return;
    }

    // Validar campos requeridos
    const connection = this.selectedEvent.environment?.connection;
    if (!connection?.bootstrapServers) {
      this._translateService.get('EVENT_STREAMING.ERROR_BOOTSTRAP_SERVERS_REQUIRED').subscribe((message: string) => {
        this.messageService.showError(message);
      });
      return;
    }

    this.isBusy = true;
    try {
      const result = await this._connectEventStreamingService.updateEventStreamConfiguration(this.selectedEvent);
      this.eventStreamingDetail?.updateOriginalConfiguration(this.selectedEvent);
      
      if (result) {
        this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
          this.messageService.showSuccess(message);
          Utils.copyDataTrigger(this.selectedEvent, this.selectedEventOrig);
        });
      } else {
        this._translateService.get('EVENT_STREAMING.ERROR_SAVING').subscribe((message: string) => {
          this.messageService.showError(message);
        });
      }
    } catch (error) {
      this._translateService.get('EVENT_STREAMING.ERROR_SAVING').subscribe((message: string) => {
        this.messageService.showError(message);
      });
    } finally {
      this.isBusy = false;
    }
  }

  public cancelChanges() {
    if (this.selectedEventOrig) {
      this.selectedEvent = Utils.copyObject(this.selectedEventOrig);
    } else {
      this.selectedEvent = null;
    }
  }

  toggleGroup(group: IEventStreamType) {
    group.isExpanded = !group.isExpanded;
  }

  // Method to handle loading changes from the child component
  public handleLoadingChange(isLoading: boolean) {
    this.isBusy = isLoading;
  }

  private _showPendingChangesDialog(saveAction: Function, cancelAction: Function) {
    const modal = this._modalService.open(
      PendingChangesConnectAlertComponent,
      { closeOnBackdropClick: false, closeOnRouterNavigation: true }
    );
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'save') {
        saveAction();
      } else {
        cancelAction();
      }
    });
  }
}
